<app-full-page-wrapper>
  <div class="card card-login">
    <div class="card-body card-body-login">
      <div class="login-flex" *ngIf="login">
        <div class="header text-center">
          <div class="minilogo"></div>
          <h1 class="h3 h3-login">Bem vindo(a) de volta!</h1>
        </div>
        <hr />
        <form (submit)="submit()" [formGroup]="form">

          <div class="form-group">
            <label class="label-login" for="identifier">CPF, CNPJ ou Email</label>
            <input id="identifier" type="text" formControlName="identifier" class="form-control input-login"
              (blur)="onIdentifierBlur()" (input)="onIdentifierInput()" placeholder="Digite seu CPF, CNPJ ou e-mail" />
          </div>

          <div class="form-group" *ngIf="needsCpf">
            <label class="label-login" for="cpf">Informe seu CPF</label>
            <input id="cpf"
                  type="text"
                  mask="000.000.000-00"
                  formControlName="cpf"
                  class="form-control input-login"
                  placeholder="Ex: 123.456.789-00" />
          </div>

          <div class="form-group" *ngIf="!isEmail">
            <label class="label-login" for="password">Senha</label>
            <input id="password" type="password" formControlName="password" appPasswordInput class="form-control input-login"
              placeholder="Informe sua senha" />
          </div>

          <button type="submit" class="btn btn-secondary btn-block send-button" [disabled]="form.invalid">
            Entrar
          </button>
          <a class="btn btn-link btn-block text-center" (click)="forgotView()">Esqueci minha Senha</a>
          

        </form>
      </div>
      <div class="login-flex" *ngIf="forgot">
        <div class="header text-center"> 
          <div class="minilogo"></div>
          <h1 class="h3 h3-login">Recuperar Senha</h1>
        </div>
        <hr />
        <form [formGroup]="formRecovery" (submit)="openRecovery()">

          <div class="form-group" onsubmit="">
            <label class="label-login" for="identifier">CPF ou CNPJ</label>
            <input
              type="text"
              formControlName="identifier"
              placeholder="Digite seu CPF ou CNPJ"
              inputmode="numeric"
              class="form-control input-login"
              (input)="onRecoveryIdentifierInput()"
            />
          </div>

          <button type="submit" class="btn btn-secondary btn-block send-button" [disabled]="formRecovery.invalid">
            Recuperar Senha
          </button>
          <a class="btn btn-link btn-block text-center" (click)="loginView()">Voltar ao login</a>
        </form>
      </div>
      <div class="login-flex" *ngIf="change">
        <div class="header text-center"> 
          <h1 class="h3 h3-login">Alterar Senha</h1>
        </div>
        <hr />
        <form [formGroup]="formToken" (submit)="changePassword()">

          <div class="form-group" onsubmit="">
            <label class="label-login" for="identifier">CPF ou CNPJ</label>
            <input id="identifier" type="numeric" formControlName="identifier" class="form-control input-login"
              placeholder="Digite seu CPF ou CNPJ" (input)="onTokenIdentifierInput()"/>
          </div>

          <div class="form-group">
            <label class="label-login" for="password">Senha</label>
            <input id="password" type="password" formControlName="newPassword" appPasswordInput class="form-control input-login"
              placeholder="Informe sua senha" />

              <div class="erro" *ngIf="!validatePassword(fToken.newPassword.value)">
                A senha precisa ter:
                <li>Pelo menos uma letra maiuscula</li>
                <li>Pelo menos uma letra minucula</li>
                <li>Pelo menos um número</li>
                <li>Pelo menos um caracter especial</li>
            </div>
          </div>

          <div class="form-group">
            <label class="label-login" for="password">Senha</label>
            <input id="password" type="password" formControlName="confirmPassword" appPasswordInput class="form-control input-login"
              placeholder="Confirme sua senha" />
            <div class="erro" *ngIf="!confirmPassword()">
                A senhas precisam ser iguais
            </div>
          </div>

          

          <div class="form-group" [class.opacityHidd]="expire" onsubmit="">
            <label class="label-login" for="document">Token</label>
            <input id="token" readonly type="text" formControlName="token" class="form-control input-login"
              placeholder="Token" />
          </div>

          <button type="submit" class="btn btn-secondary btn-block send-button" [disabled]="formToken.invalid">
            Alterar Senha
          </button>
          <a class="btn btn-link btn-block text-center" (click)="loginView()">Voltar ao login</a>
        </form>
      </div>
      <div class="row-term" *ngIf="term">
        <h1 class="h3 text-center">Termo de Aceite</h1>
        <hr />
        <div class="box-term" [innerHTML]="termText">
        </div>
        <button type="submit" class="btn btn-secondary btn-block send-button" (click)="read()">
          Li e concordo com os termos de aceite
        </button>
      </div>

      <div class="row-select" *ngIf="select">
        <h3>Selecione a empresa</h3>
        <hr />
        <div class="list-company">
          <div class="box-company" *ngFor="let item of listCompanyOne" (click)="selectInsurance(item)">
            {{item.company.companyName}}
          </div>
        </div>
      </div>

      <div class="row-select" *ngIf="insurance">
        <h3>Selecione a seguradora</h3>
        <span (click)="backToCompany()" class="link-back">Voltar</span>
        <hr />
        <div class="list-company">
          <div class="box-company" *ngFor="let item of listCompanyTwo" (click)="selectInsurance(item)">
            {{item.companyName}}
          </div>
        </div>
      </div>
      <div class="login-background">
        Há 15 anos no mercado, o Grupo Planetun oferece uma gama de serviços e soluções para o mercado automotivo e de seguros.
      </div>
      
    </div>
  </div>
</app-full-page-wrapper>